<template>
  <div>
    <div class="verificationImg" style="margin-bottom: 20px;">
      <el-image
        style="width: 100%; height: 100px"
        :src="form.url"
        :fit="fit"
      />
    </div>
    <div style="margin-bottom: 20px;">
      <el-input v-model="imageCode" maxlength="20" :placeholder="title" />
    </div>
    <div style="margin-bottom: 20px;text-align: center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="receive">确定</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        form:{
          url:''
        },
        fit:'fill',
        imageCode :'',
        Privacyurl: this.BASE_API_URL,
        title:'请输入验证码计算结果'
      }
    },
    created() {
      this.url = ''
    },
    methods:{
        getVerificationCodeImage(imgurl,title){
          if(title){
            this.title = title
          }
          this.$set( this.form, 'url', imgurl )
          this.$forceUpdate()
        },
        receive(){
          if(!this.imageCode){
            this.$message.error("请输入验证码");
          }else{

            this.$emit('receive', this.imageCode)
            this.form.url = ''
            this.imageCode = ''
          }
        },
        cancel(){
          this.form.url = ''
          this.imageCode = ''
          this.$emit('cancel')
        }
    }
  }
</script>

<style lang="scss">
  .verificationImg{
    width: 100%;
    display: flex;
    align-items: center;
  }
</style>
